import {Alert, Button, Card, Datepicker} from "flowbite-react";
import React, {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import {AppContext} from "../../App.context";
import {convertArrivalDate, convertDepartureDate, day, isHighSeason} from "../../lib/utils";
import {useNavigate} from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

export default function SearchRoomCardComponent({top = true}: {top?: boolean}) {
    const {t} = useTranslation();
    const {language, changeArrivalDate, changeDepartureDate, config} = useContext(AppContext);
    const navigate = useNavigate();

    const minFrom = new Date();
    const [arrival, setArrival] = useState(convertArrivalDate(minFrom));
    const [highSeasonActive, setHighSeasonActive] = useState(isHighSeason(config, arrival));
    const [minTo, setMinTo] = useState(() => {
        const minToDate = highSeasonActive ? new Date(arrival.getTime() + day * config.highSeasonMinimalOrderDays) :  new Date(arrival.getTime() + day * config.minimalOrderDays);
        return minToDate;
    });
    const [departure, setDeparture] = useState(convertDepartureDate(new Date(minTo)));

    const handleArrivalDate = (date: Date) => {
        setHighSeasonActive(isHighSeason(config, date));
        
        const minToDate = highSeasonActive ? new Date(date.getTime() + day * config.highSeasonMinimalOrderDays) :  new Date(date.getTime() + day * config.minimalOrderDays);

        setArrival(convertArrivalDate(date));
        setMinTo(minToDate)

        if (departure < minToDate) setDeparture(minToDate);
    }

    const handleDepartureDate = (date: Date) => {
        setDeparture(convertDepartureDate(date));
    }

    const search = () => {
        changeArrivalDate(arrival);
        changeDepartureDate(departure);

        navigate('/book', {unstable_viewTransition: true})
    }

    return (
        <Card className={`w-full ${top ? 'rounded-b-xl rounded-t-none' : 'rounded-t-xl rounded-b-none'}`}>
            <div className={'flex flex-col basis-full gap-6 py-6 lg:px-20 xl:px-44 lg:flex-row'}>
                <div className={'flex flex-col basis-1/3 px-6 lg:px-0'}>
                    <div className={'py-2'}>
                        {t('input.date_arrival')}
                    </div>
                    <Datepicker
                        showTodayButton={false}
                        showClearButton={false}
                        sizing={'lg'}
                        className={''}
                        language={language}
                        title={t('input.date_arrival')}

                        onSelectedDateChanged={handleArrivalDate}
                        minDate={minFrom}
                        defaultDate={arrival}
                        value={arrival.toLocaleDateString()}
                    />
                </div>
                <div className={'flex flex-col basis-1/3 px-6 lg:px-0'}>
                    <div className={'py-2'}>
                        {t('input.date_departure')}
                    </div>
                    <Datepicker
                        key={departure.toISOString()}
                        sizing={'lg'}
                        title={t('input.date_departure')}
                        showTodayButton={false}
                        showClearButton={false}
                        language={language}

                        onSelectedDateChanged={handleDepartureDate}
                        minDate={minTo}
                        defaultDate={departure}
                        value={departure.toLocaleDateString()}
                    />
                </div>
                <div className={'flex flex-col justify-end basis-1/3 px-6 lg:px-0'}>
                    <Button size={'xl'} color={'default'} className={'w-full'} onClick={search}>{t('button.find_rooms')}</Button>
                </div>
            </div>

            {highSeasonActive && (
                <div className={'flex flex-col w-full lg:w-4/5 self-center pb-6 px-6'}>
                    <Alert
                        color={'warning'}
                        icon={FaExclamationTriangle}
                        rounded
                    >
                        <strong>{t('alert.attention')}</strong>
                        <br/>
                        {t('alert.high_season_minimal_order_days')} <strong>{config.highSeasonMinimalOrderDays}</strong>.
                    </Alert>

                </div>
            )}
        </Card>
    )
}